<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/slideBanner')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="name_banner">Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="name_banner" v-model="name_banner" name="name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="image_banner">Image</label>
                </b-col>
                <b-col sm="10">
                  <b-form-file name="file" v-validate="'required'" @change="previewImage" accept="image/*" v-model="file" :state="Boolean(file)" placeholder="Choose a file..."></b-form-file>
                  <!-- <div class="mt-3">Selected file: {{file && file.name}}</div> -->
                  <div class="image-preview" v-if="imageData.length > 0">
                      <img class="preview" :src="imageData">
                  </div>
                  <span class="error">{{ errors.first('file') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="url_banner">URL</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="url_banner" v-model="url" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="image_banner">Status</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="status" v-validate="'required'" v-model="selected" :options="options" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('status') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'

export default {
  name: 'addSlideBanner',
  data: function () {
    return {
      messageError: 'data saved successfully!',
      titleMessageError: 'Success',
      notificationSystem: {
        options: {
          success: {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          }
        }
      },
      name_banner: '',
      imageData: '',
      file: null,
      url: '',
      selected: null,
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ]
    }
  },
  methods: {
    validateRegister () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
          var data = new FormData()
          data.append('photos', this.file)
          data.append('text', this.name_banner)
          data.append('status', this.selected)
          data.append('youtube_url', this.url)
          axios.post('compro/v1/banner/', data).then(response => {
            // console.log('test', response)
            this.$router.push('/slideBanner')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
          // create a new FileReader to read this image and convert to base64 format
          var reader = new FileReader();
          // Define a callback function to run, when FileReader finishes its job
          reader.onload = (e) => {
              // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
              // Read image as base64 and set to imageData
              this.imageData = e.target.result;
          }
          // Start the reader job - read file as a data url (base64 format)
          reader.readAsDataURL(input.files[0]);
      }
    }
  }
}
</script>

<style>
</style>
